"use client";

import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Shield, Users, TrendingUp } from "lucide-react";
export default function WhyChooseUs() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const benefits = [{
    icon: Shield,
    title: "Real-World Integration",
    description: "Not all technology experts understand the delicate balance between high-end systems and day-to-day business needs. We bring decades of experience actually integrating solutions into real businesses—ensuring your tech works for your people, not the other way around."
  }, {
    icon: Users,
    title: "World-Class, Not a World Away",
    description: "We believe that elite technology shouldn't feel cold or distant. By keeping your customers’ experience at the forefront, we provide sophisticated tools that maintain the personal, neighborly feel that your business was built on."
  }, {
    icon: TrendingUp,
    title: "Innovation Meets Trust",
    description: "Technology moves fast, but old-school reliability never goes out of style. We blend cutting-edge AI capabilities with the secure, dependable oversight of experienced professionals you can actually pick up the phone and call."
  }];
  return <section id="why-choose-us" ref={sectionRef} className="relative overflow-hidden bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12 items-center">
          {}
          <div className="space-y-6">
            <div className={`transition-all duration-[var(--duration-fast)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              <h2 className="text-3xl font-display font-bold text-foreground md:text-4xl mb-2">
                A Different Approach to Technology
              </h2>
            <p className="text-muted mb-8">
              We build technology solutions to work around the clock so you don't have to.
            </p>
            </div>

            <div className="space-y-4">
              {benefits.map((benefit, i) => {
              const Icon = benefit.icon;
              return <Card key={i} data-index={i} className={`border border-border shadow-soft hover:shadow-medium transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
                transitionDelay: isVisible ? `${i * 150}ms` : "0ms"
              }}>
                    <CardContent className="flex items-start gap-4 p-6">
                      <div className="flex-shrink-0 rounded-lg bg-primary/10 p-3">
                        <Icon className="h-6 w-6 text-primary" />
                      </div>
                      <div className="flex-1">
                        <h3 className="font-display font-semibold text-lg text-foreground mb-2">
                          {benefit.title}
                        </h3>
                        <p className="text-muted text-sm leading-relaxed">
                          {benefit.description}
                        </p>
                      </div>
                    </CardContent>
                  </Card>;
            })}
            </div>
          </div>

          {}
          <div className="relative flex items-center justify-center lg:justify-end">
            <div className={`relative transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`} style={{
            transitionDelay: isVisible ? "300ms" : "0ms"
          }}>
              <div className="relative w-full max-w-md aspect-square">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-accent/20 to-secondary/20 rounded-full blur-3xl"></div>
                <img src="https://enough-jackass.10web.cloud/wp-content/uploads/2026/01/modern-empty-elegant-office-with-windows-and-workp-2025-03-15-09-48-02-utc-scaled.jpg" alt="Coastal AI Technology" className="relative z-10 h-full object-contain" />
                <div className="absolute top-1/4 -right-4 w-24 h-24 bg-accent/30 rounded-full blur-2xl"></div>
                <div className="absolute bottom-1/4 -left-4 w-32 h-32 bg-primary/20 rounded-full blur-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}